
export default {
  props: {
    value: [Object, Number],
    enableColumnResize: Boolean,
  },
  data() {
    return {
      mouseX: 0,
      initialX: 0,
      initialClientWidth: 0,
      columnIndex: 0,
      columnResize: null,
      resizing: false,
      sizes: this.value,
    }
  },
  mounted() {
    if (this.enableColumnResize) {
      window.addEventListener("pointermove", this.pagePointerMove, {passive: true})
      window.addEventListener("pointerup", this.pagePointerUp, {passive: true})
    }
  },
  beforeDestroy() {
    window.removeEventListener("pointermove", this.pagePointerMove)
    window.removeEventListener("pointerup", this.pagePointerUp)
  },
  methods: {
    pagePointerMove(evt) {
      this.mouseX = evt.clientX
    },
    pagePointerUp() {
      setTimeout(() => this.resizing = false, 100)
      this.$emit("input", this.sizes)

      this.initialClientWidth = null
      this.columnIndex = null
      this.initialX = null
      this.columnResize = null
    },

    pointerDown(evt, index, column) {
      this.resizing = true
      this.columnResize = column
      this.initialX = evt.clientX

      const firstChild = this.$refs.header.children[0]
      if (firstChild && !firstChild.classList.contains("table-cell")) index++

      this.columnIndex = index
      this.initialClientWidth = this.$refs.header.children[index].clientWidth
    },
  },
  computed: {
    mouseWidth() {
      return this.mouseX - this.initialX
    },
    newColumnSize() {
      if (!this.columnResize) return;
      const width = this.initialClientWidth + this.mouseWidth
      if (width < 50) return 50
      return width
    },
    sizedColumns() {
      const sizes = this.sizes
      if (!sizes) return this.columns.map(column => ({column}))

      const variables = this.variables
      return this.columns.map((column, i) => ({
        column,
        style: sizes[variables[i]] && {
          'max-width': sizes[variables[i]] + 'px !important',
          'min-width': sizes[variables[i]] + 'px !important',
        },
      }))
    },
  },
  watch: {
    value(sizes) {
      this.sizes = sizes
    },
    newColumnSize(size) {
      if (size && this.columnResize) {
        this.sizes = {
          ...this.sizes,
          [this.columnResize]: size,
        }
      }
    },
  },
}
